import { useQuery } from 'react-query';
import { AssignerPrograms } from '@oh-vcp/components-common';
import { AxiosError } from 'axios';
import apiService from './apiService';

const fetchAssignerPrograms = async (): Promise<AssignerPrograms> => {
  const url = `programs/myprogramsasassigner`;
  const response = await apiService.get(url);
  return response.data;
};

const useAssignerPrograms = () => {
  return useQuery<AssignerPrograms, AxiosError>(
    ['assignerPrograms'],
    () => fetchAssignerPrograms(),
    {
      refetchOnWindowFocus: false
    }
  );
};

export default useAssignerPrograms;
